import '../../style/base.css';
import '../../badge/index.css';
import '../../icon/index.css';
import '../index.css';